import React from "react";
import { Typography, Tag } from "antd";

const { Text } = Typography;

interface IStepHeaderProps {
    currentStep: number;
    clusterCount: number;
    productCount: number;
    showCounts: boolean;
    totalCampaignsCount?: number;
}

const StepHeader: React.FC<IStepHeaderProps> = ({
    currentStep,
    clusterCount,
    productCount,
    showCounts,
    totalCampaignsCount,
}) => {
    const headers = {
        0: {
            title: "Selected Items",
            subtitle: showCounts
                ? `Clusters: ${clusterCount} • Products: ${productCount}`
                : "",
        },
        1: {
            title: "Create Collections",
            subtitle: "Configure campaigns for each selected cluster",
        },
        2: {
            title: "Review Campaigns",
            subtitle:
                "Review all campaign combinations and their budget. Campaign names can be edited.",
        },
    };

    const { title, subtitle } = headers[currentStep as keyof typeof headers];

    if (currentStep === 0 && !showCounts) return null;

    return (
        <div className="selected-items-header">
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                }}
            >
                <div>
                    <Text className="selected-items-title">{title}</Text>
                    <Text
                        className={`selected-items-count ${
                            currentStep === 0 ? "" : "fs-7"
                        }`}
                    >
                        {subtitle}
                    </Text>
                </div>
                {currentStep === 2 && totalCampaignsCount !== undefined && (
                    <Tag
                        className={`campaign-tag ${
                            totalCampaignsCount === 0 ? "count-0" : "count"
                        }`}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {`${totalCampaignsCount} Campaigns`}
                    </Tag>
                )}
            </div>
        </div>
    );
};

export default StepHeader;